"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedValuesRule = void 0;
var validation_rule_1 = require("./validation-rule");
var property_1 = require("./property");
var property_chain_1 = require("./property-chain");
var AllowedValuesRule = /** @class */ (function (_super) {
    __extends(AllowedValuesRule, _super);
    /**
     * Creates a rule that validates whether a selected value or values is in a list of allowed values.
     * @param rootType The root type to bind the rule to
     * @param options The rule configuration options
     */
    function AllowedValuesRule(rootType, options) {
        var _this = this;
        // ensure the rule name is specified
        options.name = options.name || "AllowedValues";
        // ensure the error message is specified
        options.message = options.message || function () { return rootType.model.getResource("allowed-values"); };
        // convert property path sources into a source function
        var source;
        if (options.source instanceof property_1.Property || options.source instanceof property_chain_1.PropertyChain) {
            var sourcePath_1 = options.source;
            options.onChangeOf = [sourcePath_1];
            options.source = source = function () { return sourcePath_1.value(this); };
        }
        else
            source = options.source;
        // create the validation function
        options.isValid = function (prop, value) {
            if (options.ignoreValidation) {
                return true;
            }
            // return true if no value is currently selected
            if (!value) {
                return true;
            }
            // get the list of allowed values of the property for the given object
            var allowed = source.call(this);
            // ensure that the value or list of values is in the allowed values list (single and multi-select)
            if (value instanceof Array) {
                return value.every(function (item) { return allowed.indexOf(item) >= 0; });
            }
            else {
                return allowed.indexOf(value) >= 0;
            }
        };
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        // store the allowed values source
        _this.source = source;
        _this.ignoreValidation = !!options.ignoreValidation;
        _this.preventInvalidValues = !!options.preventInvalidValues;
        return _this;
    }
    AllowedValuesRule.prototype.values = function (obj) {
        return this.source.call(obj);
    };
    AllowedValuesRule.prototype.toString = function () {
        return this.property.containingType.fullName + "." + this.property.name + " allowed values";
    };
    return AllowedValuesRule;
}(validation_rule_1.ValidationRule));
exports.AllowedValuesRule = AllowedValuesRule;
